export const SegmentActions = {
    DELETE: 'delete',
    HOUSEHOLD_TARGETING: 'household-targeting',
};
